// One entry per blog post. To add a new post later, add one object to this
// list — the blog list page and the post page both read from here.

export const BLOG_BASE_PATH = '/blog';
export const blogPostPath = (slug) => `${BLOG_BASE_PATH}/${slug}`;

export const posts = [
  {
    slug: 'portable-toilet-rental-cost-bangalore',
    title: 'How Much Does Portable Toilet Rental Cost in Bangalore?',
    excerpt:
      "If you're planning an event and wondering how portable toilet rental is priced, here's a plain answer, in simple terms.",
    date: '2026-09-25',
    readTime: '4 min read',
    // The body is a list of blocks so the page can render headings and
    // paragraphs in order. type: 'p' = paragraph, 'h2' = sub-heading,
    // 'list' = bullet list.
    body: [
      {
        type: 'p',
        text: "One of the first questions people ask us is simple: how much does it cost to rent a portable toilet? There isn't one fixed number, because it depends on a few things, but here's how it actually works.",
      },
      {
        type: 'h2',
        text: 'The basic rate',
      },
      {
        type: 'p',
        text: 'Portable toilets on rent usually cost between ₹1,500 and ₹3,000 per unit per day. This rate covers one event that runs for 6 to 12 hours, which fits most weddings, parties, and single-day functions.',
      },
      {
        type: 'h2',
        text: 'What changes the price',
      },
      {
        type: 'list',
        items: [
          'How many units you need — the price is worked out per unit, so it scales with your event size.',
          'How many days you need them for — a single-day wedding is priced differently from a multi-day event or a construction site booking.',
          'Transportation — delivery and pickup are charged separately from the rental itself, based on how many units you are booking and how far your venue is from us.',
        ],
      },
      {
        type: 'h2',
        text: 'Is there a minimum order?',
      },
      {
        type: 'p',
        text: "No. There's no minimum order, so you can book exactly what your event needs, whether that's a single unit or a large number of them.",
      },
      {
        type: 'h2',
        text: 'How to get an exact price',
      },
      {
        type: 'p',
        text: 'Because the final price depends on your quantity, number of days, and venue distance, the fastest way to know your exact cost is to send us your event details. Tell us your event date, how many guests you expect, how many days you need the units for, and your venue location, and we will work out a quote for you.',
      },
    ],
  },
];
